import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoClip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideoClip"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM5 5V7H7V5H5ZM17 5V7H19V5H17ZM19 9H17V11H19V9ZM19 13H17V15.4444H19V13ZM19 17.4444H17V19H19V17.4444ZM15 13V11H9V13H15ZM7 19V17H5V19H7ZM5 15H7V13H5V15ZM5 11H7V9H5V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoClip;
